const GroupRole = {
    DEPARTMENT_HEAD: "DEPARTMENT_HEAD",
    DIVISION_HEAD: "DIVISION_HEAD",
    MEMBER: "MEMBER",
}

const GroupType = {
    DEPARTMENT: "DEPARTMENT",
    DIVISION: "DIVISION",
}

export {
    GroupRole,
    GroupType,
}


// WEBPACK FOOTER //
// ./src/services/internalGroups/constants.js